export const highlightText = (text: string, query: string) => {
  if (!query) return text;

  const parts = text.split(new RegExp(`(${query})`, "gi"));
  return parts.map((part, index) => (
    <span
      key={index}
      style={
        part.toLowerCase() === query.toLowerCase()
          ? {
              backgroundColor: "yellow",
            }
          : undefined
      }
    >
      {part}
    </span>
  ));
};
